/**
 * StorageFilesystemEntryType
 */
export enum StorageFilesystemEntryType {
    FILE = 'file',
    DIRECTORY = 'directory'
}
